var map = {
	"./makhan-chesse-herbs (1).png": 2766,
	"./makhan-chesse-herbs (2).png": 1967,
	"./makhan-chesse-herbs (3).png": 5912,
	"./makhan-chesse-herbs (4).png": 2761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5923;